import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/PwaRegistrar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/WebsiteChatbotWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/index.css");
